<template>
    <div class="main-div">
        <header-edit-contact @closeDialog="closeDialog" />
        <main-edit-contact :contact="contact" @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderEditContact from './HeaderEditContact.vue';
import MainEditContact from './MainEditContact.vue';

const dialogRef = getDialogRef(ModalNames.EDIT_CONTACT);
const contact = computed(() => dialogRef.value?.data?.contact);

const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-md sm:w-[440px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>
